<section>
  <div id="registerBox">
    <div
      id="popUpInfoContainer"
      class="popUpInfoContainer dNone"
      (click)="hideRules()"
    >
      <div class="popUpInfo">
        <h4>Passwort-Regeln:</h4>
        <p>
          Das Passwort muss mindestens 8 Zeichen lang sein und mindestens je
          einen Großbuchstaben, Kleinbuchstaben, eine Zahl und ein erlaubtes
          Sonderzeichen
          (<span>&#33;&#64;&#35;&#36;&#37;&#94;&#38;&#42;&#40;&#41;&#95;&#43;&#45;&#61;&#63;&#8364;</span>)
          enthalten.
        </p>
      </div>
    </div>
    <h1>Registrierung</h1>
    <p>
      Bitte versteht, dass wir nur verifizierte Familienmitglieder zulassen
      dürfen. Für die Registrierung braucht ihr die Empfehlung eines bereits
      registrierten, uns bekannten Nutzers oder müsst euch anderweitig
      ausweisen. In dem Fall klickt bitte die Box "Ich habe keinen Bürgen" an.
    </p>
    <b
      >Die Probleme mit dem iPhones sollten behoben sein - wenn nicht, bitte
      informiert Anne!</b
    >
    <form #registerForm="ngForm" (ngSubmit)="onSubmit(registerForm)">
      <div class="registerInputBox">
        <label for="email">Email:</label>
        <input
          type="email"
          id="email"
          name="email"
          [(ngModel)]="formData.email"
          required
        />
      </div>
      @if (showErrorEmailAlert) {
        <div class="alert">Bitte gibt eine valide Email ein.</div>
      }

      <div class="registerInputBox">
        <label for="first_name">Vorname:</label>
        <input
          type="text"
          id="first_name"
          name="first_name"
          [(ngModel)]="formData.first_name"
          required
        />
        <label for="last_name">Nachname:</label>
        <input
          type="text"
          id="last_name"
          name="last_name"
          [(ngModel)]="formData.last_name"
          required
        />
      </div>
      <div class="registerInputBox">
        <label class="passwort" for="password"
          >Passwort:
          <div class="labelInfoText" (click)="showRules()">
            (Passwortregeln)
          </div></label
        >
        <div class="passwordContainer">
          <input
            [type]="passwordVisible ? 'text' : 'password'"
            id="password"
            name="password"
            [(ngModel)]="formData.password"
            required
          />
          <div
            type="button"
            (click)="togglePasswordVisibility('passwort')"
            class="togglePassword"
          >
            @if (passwordVisible) {
              <span>👁️</span>
            }
            @if (!passwordVisible) {
              <span>🙈</span>
            }
          </div>
        </div>
      </div>
      @if (showErrorPasswordAlert) {
        <div class="alert">
          Das Passwort muss mindestens 8 Zeichen lang sein und mindestens je
          einen Großbuchstaben, Kleinbuchstaben, eine Zahl und ein erlaubtes
          Sonderzeichen
          (<span>&#33;&#64;&#35;&#36;&#37;&#94;&#38;&#42;&#40;&#41;&#95;&#43;&#45;&#61;&#63;&#8364;</span>)
          enthalten.
        </div>
      }

      <div class="registerInputBox">
        <label for="confirmPassword">Passwort Wiederholung:</label>
        <div class="passwordContainer">
          <input
            [type]="confirmPasswordVisible ? 'text' : 'password'"
            id="confirmPassword"
            name="confirmPassword"
            [(ngModel)]="formData.confirmPassword"
            required
          />
          <div
            type="button"
            (click)="togglePasswordVisibility('confirm')"
            class="togglePassword"
          >
            @if (passwordVisible) {
              <span>👁️</span>
            }
            @if (!passwordVisible) {
              <span>🙈</span>
            }
          </div>
        </div>
      </div>
      @if (showErrorPasswordMatchAlert) {
        <div class="alert">Passwörter entsprechen einander nicht.</div>
      }
      <div class="registerInputBox">
        <label for="families"
          >Ich möchte mich für diese Familie(n) registrieren:</label
        >
        <div class="checkboxContainer">
          <input
            type="checkbox"
            id="kempe"
            value="kempe"
            [checked]="formData.selectedFamilies.includes('kempe')"
            (change)="onCheckboxChange('kempe')"
          />
          <label for="kempe">Stammbaum Kempe</label>
        </div>
        <div class="checkboxContainer">
          <input
            type="checkbox"
            id="huenten"
            value="huenten"
            [checked]="formData.selectedFamilies.includes('huenten')"
            (change)="onCheckboxChange('huenten')"
          />
          <label for="huenten">Stammbaum Hünten</label>
        </div>
      </div>
      <div class="regDivider"></div>
      <div class="registerInputBox">
        <div div class="checkboxContainer">
          <input
            type="checkbox"
            id="guarantor"
            name="guarantor"
            [checked]="formData.guarantor"
            (change)="onCheckboxChange('guarantor')"
          />
          <label for="guarantor">Ich habe einen Bürgen.</label>
        </div>
        <div class="checkboxContainer">
          <input
            type="checkbox"
            id="noGuarantor"
            name="noGuarantor"
            [checked]="formData.noGuarantor"
            (change)="onCheckboxChange('noGuarantor')"
          />
          <label for="noGuarantor"
            >Ich habe keinen Bürgen, bitte kontaktiert mich.</label
          >
        </div>
      </div>
      @if (showErrorChooseGuarantor) {
        <div class="alert">Bitte wähle eine von beiden Möglichkeiten aus.</div>
      }

      <div class="registerInputBox">
        <label for="guarantorEmail">Die Email meines Bürgen ist:</label>
        <input
          type="email"
          id="guarantorEmail"
          name="guarantorEmail"
          [(ngModel)]="formData.guarantorEmail"
          [disabled]="!formData.guarantor"
        />
      </div>
      @if (showErrorGuarantorEmailAlert) {
        <div class="alert">Bitte gibt eine valide Email ein.</div>
      }

      <div>
        @if (errorMessage) {<p class="errorMessage">{{ errorMessage }}</p>}
        
        <p id="forgotLink"></p>
      </div>
      <button
        id="submitButton"
        type="submit"
        [disabled]="!registerForm.valid || this.sent"
      >
        {{ this.buttonText }}
      </button>
    </form>

    <p>
      Hast du schon einen Account? Gehe zum <a routerLink="/login">Login</a>
    </p>
  </div>

  <div id="popUpContainer" class="popUpInfoContainer dNone">
    <div class="popUpInfo">
      <h1 id="infoBox" class="center"></h1>
    </div>
  </div>
</section>
<app-scroll-to-top-button></app-scroll-to-top-button>
